(function() {
    'use strict';

    angular.module('allegro.constants', [])
        .constant('allegroOfferMessagesConst', {
            add: 'Dodano ofertę!',
            update: 'Oferta została zaktualizowana!',
            delete: 'Oferta została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('allegroOfferPermissionsConst', {
            view: {
                value: 'view_offer',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu oferty!'
            },
            add: {
                value: 'add_offer',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania oferty!'
            },
            update: {
                value: 'change_offer',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji oferty!'
            },
            delete: {
                value: 'delete_offer',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania oferty!'
            }
        })
        .constant('allegroOfferCompleteOptsConst', {
            true: {
                value: 'True',
                title: 'Tak'
            },
            false: {
                value: 'False',
                title: 'Nie'
            },
        })

        .constant('allegroAccountMessagesConst', {
            add: 'Dodano nowe konto!',
            update: 'Konto zostało zaktualizowane!',
            delete: 'Konto zostało usunięte!',
            error: 'Wystąpił bład!'
        })
        .constant('allegroAccountPermissionsConst', {
            view: {
                value: 'view_account',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu konta!'
            },
            add: {
                value: 'add_account',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania konta!'
            },
            update: {
                value: 'change_account',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji konta!'
            },
            delete: {
                value: 'delete_account',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania konta!'
            }
        })
        .constant('allegroConfigMessagesConst', {
            add: 'Dodano configurację!',
            update: 'Konfiguracja została zaktualizowana!',
            delete: 'Konfiguracja została usunięta!',
            error: 'Wystąpił bład!',
            noConfigurationError: 'Konto nie ma zapisanej konfiguracji połączenia, uzupełnij w ustawieniach konta Allegro.',
            createDeviceFlowSuccess: 'Wygenerowano poprawnie kod urządzenia, przejdź do Allegro aby potwierdzić dostęp systemu do zasobów Konta Allegro.',
            accessTokenRevokeError: 'Nie możesz rozłączyć aplikacji, konto nie ma ważnego tokenu dostępowego.',
            accessTokenRetriveSuccess: 'Połączenie konta zostało poprawnie potwierdzone w Allegro',
            accessTokenRevokeSuccess: 'Połączenie konta z Allegro zostało zakończone',
            revokedTokenInvalidEmailError: 'Adres e-mail konta z którym próbujesz się połączyć nie zgadza się z adresem wprowadzonym w panelu admina.',
            revokedTokenInvalidAccountIdError: 'To konto Allegro jest inne niż to, które zostało wcześniej połączone. Upewnij się, że logujesz się na właściwe konto.',
        })
        .constant('allegroConfigPermissionsConst', {
            view: {
                value: 'view_configuration',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu konfiguracji!'
            },
            add: {
                value: 'add_configuration',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania konfiguracji!'
            },
            update: {
                value: 'change_configuration',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji konfiguracji!'
            },
            delete: {
                value: 'delete_configuration',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania konfiguracji!'
            }
        })

        .constant('allegroSellerMessagesConst', {
            add: 'Dodano sprzedawcę!',
            update: 'Zaktualizowano sprzedawcę!',
            delete: 'Sprzedawca został usunięty!',
            error: 'Wystąpił bład!',
        })
        .constant('allegroSellerPermissionsConst', {
            view: {
                value: 'view_accountseller',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu sprzedawcy!'
            },
            add: {
                value: 'add_accountseller',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania sprzedawcy!'
            },
            update: {
                value: 'change_accountseller',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji sprzedawcy!'
            },
            delete: {
                value: 'delete_accountseller',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania sprzedawcy!'
            }
        })

        .constant('allegroSenderMessagesConst', {
            add: 'Dodano nadawcę!',
            update: 'Zaktualizowano nadawcę!',
            delete: 'Nadawca został usunięty!',
            error: 'Wystąpił bład!',
        })
        .constant('allegroSenderPermissionsConst', {
            view: {
                value: 'view_accountsender',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu nadawcy!'
            },
            add: {
                value: 'add_accountsender',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania nadawcy!'
            },
            update: {
                value: 'change_accountsender',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji nadawcy!'
            },
            delete: {
                value: 'delete_accountsender',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania nadawcy!'
            }
        })

        .constant('allegroCodReceiverMessagesConst', {
            add: 'Dodano odbiorcę przelewu!',
            update: 'Zaktualizowano odbiorcę przelewu!',
            delete: 'Odbiorcę przelewu został usunięty!',
            error: 'Wystąpił bład!',
        })
        .constant('allegroCodReceiverPermissionsConst', {
            view: {
                value: 'view_accountcashondeliveryreceiver',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu odbiorcy przelewu!'
            },
            add: {
                value: 'add_accountcashondeliveryreceiver',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania odbiorcy przelewu!'
            },
            update: {
                value: 'change_accountcashondeliveryreceiver',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji odbiorcy przelewu!'
            },
            delete: {
                value: 'delete_accountcashondeliveryreceiver',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania odbiorcy przelewu!'
            }
        })

        .constant('allegroResponsibleProducerMessagesConst', {
            add: 'Dodano osobę odpowiedzialną za zgodność produktu!',
            update: 'Zaktualizowano osobę odpowiedzialną za zgodność produktu!',
            delete: 'Osobę odpowiedzialna za zgodność produktu została usunięta!',
            error: 'Wystąpił bład!',
        })
        .constant('allegroResponsibleProducerPermissionsConst', {
            view: {
                value: 'view_accountresponsibleproducer',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu nadawcy!'
            },
            add: {
                value: 'add_accountresponsibleproducer',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania nadawcy!'
            },
            update: {
                value: 'change_accountresponsibleproducer',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji nadawcy!'
            },
            delete: {
                value: 'delete_accountresponsibleproducer',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania nadawcy!'
            }
        })

        .constant('allegroSafetyInformationMessagesConst', {
            add: 'Dodano informację bezpieczeństwa produktu!',
            update: 'Zaktualizowano informację bezpieczeństwa produktu!',
            delete: 'Informacja o bezpieczeństwie produktu została usunięta!',
            error: 'Wystąpił bład!',
        })
        .constant('allegroSafetyInformationPermissionsConst', {
            view: {
                value: 'view_accountproductsafetyinformation',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu nadawcy!'
            },
            add: {
                value: 'add_accountproductsafetyinformation',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania nadawcy!'
            },
            update: {
                value: 'change_accountproductsafetyinformation',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji nadawcy!'
            },
            delete: {
                value: 'delete_accountproductsafetyinformation',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania nadawcy!'
            }
        })

        .constant('allegroThreadPermissionsConst', {
            view: {
                value: 'view_thread',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu wiadomości!'
            },
            add: {
                value: 'add_thread',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania wiadomości!'
            },
            update: {
                value: 'change_thread',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji wiadomości!'
            },
            delete: {
                value: 'delete_thread',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania wiadomości!'
            }
        })
        .constant('allegroThreadMessagesConst', {
            add: 'Dodano wiadomość w wątku!',
        })
        .constant('allegroOfferCmdMessageConst', {
            changeDeliveryTime: 'Pomyślnie zaktualizowano czas wysyłki!',
            changePrice: 'Pomyślnie zaktualizowano cenę!',
        })
        .constant('allegroOfferCmdConst', (
            function () {
                var obj = {
                    ownPriceOpt: 'own_price',
                    modifyOwnPriceOpt: 'modify_own_price',
                    additionOperationOpt: 'addition',
                    substractOperationOpt: 'substract',
                    priceModificatorOpt: 'price',
                    percentageModificatorOpt: 'percentage'
                };

                obj.modifyTypeOpts = [
                    {
                        value: obj.ownPriceOpt,
                        name: 'ustaw swoją cenę'
                    },
                    {
                        value: obj.modifyOwnPriceOpt,
                        name: 'dodaj lub odejmij kwotę lub procent od obecnej ceny'
                    }
                ];

                obj.operationOpts = [
                    {
                        value: obj.additionOperationOpt,
                        name: 'dodaj'
                    },
                    {
                        value: obj.substractOperationOpt,
                        name: 'odejmij'
                    }
                ];

                obj.modificatorOpts = [
                    {
                        value: obj.priceModificatorOpt, name: 'kwotę'
                    },
                    {
                        value: obj.percentageModificatorOpt, name: 'procent'
                    }
                ];

                return obj;
            })());
        })();
